export default __webpack_public_path__ + "7be31bb416ffe504e236d9d3edb258de.png";